module.exports = __webpack_public_path__ + "img/zc-logo-bg.f452b841.png";